import { render, staticRenderFns } from "./SelectView.vue?vue&type=template&id=11b455bc&"
import script from "./SelectView.vue?vue&type=script&lang=ts&"
export * from "./SelectView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports